module.exports = __webpack_public_path__ + "img/404.64578a56.png";